import { Link } from "react-router-dom";
import { Briefcase } from "lucide-react";
import { Button } from "./ui/button";

export function Header() {
  return (
    <header className="sticky top-0 z-50 w-full bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border">
      <div className="container flex h-16 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-bold text-xl text-foreground tracking-tight">
          <Briefcase className="w-6 h-6 text-cyan-600" />
          Pro@Shakatah
        </Link>
        
        <nav className="hidden md:flex items-center gap-8">
          <Link to="/" className="text-sm font-medium text-foreground hover:text-cyan-600 transition-colors">
            Home
          </Link>
          <a href="/#how-it-works" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            How It Works
          </a>
          <Link to="/pricing" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <Button asChild variant="outline" size="sm">
            <Link to="/login">Log In</Link>
          </Button>
          <Button asChild size="sm" className="bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600">
            <Link to="/login?tab=signup">Sign Up Free</Link>
          </Button>
        </div>
      </div>
    </header>
  );
}
